import { createAction } from 'redux-actions';

export const getInvestmentPerformanceV2 = createAction('GET_INVESTMENT_PERFORMANCE_V2', (payload) => payload, (payload, meta) => meta);
export const getInvestmentPerformanceV2Success = createAction('GET_INVESTMENT_PERFORMANCE_V2_SUCCESS');
export const getInvestmentPerformanceV2Failure = createAction('GET_INVESTMENT_PERFORMANCE_V2_FAILURE');
